/**
 * Sticky header: hides on scroll-down, reveals condensed on scroll-up, full at
 * the top. Tracks scroll direction between frames; the CSS shell reserves space.
 */
const TOP_THRESHOLD = 4; // px from the top still counted as "at the top"
const SCROLL_DELTA = 6; // ignore movement smaller than this to avoid jitter

export default class StickyHeader {
    constructor() {
        const header = document.querySelector('.js-header');

        if (!header) {
            return;
        }

        this.header = header;
        this.lastY = Math.max(window.scrollY, 0);
        this.engageOffset = header.offsetHeight; // don't hide until scrolled past the header
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // Don't leave focusable nav stranded off-screen for keyboard users.
        header.addEventListener('focusin', () => header.classList.remove('is-retracted'));

        this.update();
    }

    onScroll() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;

        window.requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
        });
    }

    update() {
        const y = Math.max(window.scrollY, 0);
        const { header } = this;

        if (y <= TOP_THRESHOLD) {
            header.classList.remove('is-stuck', 'is-retracted');
            this.lastY = y;

            return;
        }

        header.classList.add('is-stuck');

        const delta = y - this.lastY;

        if (Math.abs(delta) <= SCROLL_DELTA) {
            return;
        }

        if (delta > 0 && y > this.engageOffset) {
            header.classList.add('is-retracted'); // scrolling down
        } else if (delta < 0) {
            header.classList.remove('is-retracted'); // scrolling up
        }

        this.lastY = y;
    }
}
